import request from '@/util/request'
export default{
	//登录
	dologin(data){
		return request({url: '/login/dologin',method: 'post',data})		
	},	
	//退出登录
	logout(data){
		return request({url: '/login/Logout',method: 'post',data})		
	},
	//忘记密码 提交邮箱	
	recoverPwd(data){
		return request({url: '/login/recoverPwd',method: 'post',data})		
	},
	//仪表台
	reportAll(data){
		return request({url: '/report/all',method: 'post',data})		
	},
	//客户管理 列表查询
	memberTrader(data){
		return request({url: '/member/trader',method: 'post',data})		
	},
	//客户管理 新增客户
	addTrader(data){
		return request({url: '/member/addTrader',method: 'post',data})
	},	
	//客户管理 编辑客户 /member/editTrader
	editTrader(data){
		return request({url: '/member/editTrader',method: 'post',data})
	},
	//余额调整
	
	setAmount(data){
		return request({url: '/member/setAmount',method: 'post',data})
	},
	//余额详情
	moneyChangeList(data){
		return request({url: '/member/moneyChangeList',method: 'post',data})
	},
	//删除客户	
	deleteTrader(data){
		return request({url: '/member/deleteTrader',method: 'post',data})
	},
	//卡密管理 列表查询
	bagList(data){
		return request({url: '/Bag/bagList',method: 'post',data})
	},
	//卡密管理 新增卡包	
	addBag(data){
		return request({url: '/Bag/addBag',method: 'post',data})
	},
	//卡密管理  编辑卡包Bag/editBag
	editBag(data){
		return request({url: '/Bag/editBag',method: 'post',data})
	},
	//查询客户余额
	traderInfo(data){
		return request({url: '/member/traderInfo',method: 'post',data})
	},
	
	//卡密查询
	cardList(data){
		return request({url: '/Bag/cardList',method: 'post',data})
	},

	//订单列表查询
	allList(data){
		return request({url: '/order/allList',method: 'post',data})
		
	},
	//订单管理  手动核销
	ensure(data){
		return request({url: '/order/ensure',method: 'post',data})
		
	},
	//订单管理  操作日志
	getOrderOperatorLog(data){
		return request({url: '/order/getOrderOperatorLog',method: 'post',data})
		
	},
	//设置 操作日志查询 user/getManagerOperators
	getManagerOperators(data){
		return request({url: '/user/getManagerOperators',method: 'post',data})
	},
	//设置 子账号设置  列表查询
	getUsers(data){
		return request({url: '/user/getUsers',method: 'post',data})
		
	},
	//设置 子账号设置  新增
	addUser(data){
		return request({url: '/user/addUser',method: 'post',data})
		
	},
	//设置 子账号设置  编辑
	setUser(data){
		return request({url: '/user/setUser',method: 'post',data})
		
	},
	//设置 子账号设置  删除
	delUser(data){
		return request({url: '/user/delUser',method: 'post',data})
		
	},
	//设置 子账号设置  重置密码
	setPassword(data){
		return request({url: '/user/setPassword',method: 'post',data})		
	},
	//产品管理  查询资料
	profileInfo(data){
		return request({url: '/profile/info',method: 'post',data})
		
	},
	//产品管理  获取密钥
	getSecrets(data){
		return request({url: '/profile/getSecrets',method: 'post',data})		
	},
	//产品管理  余额详情	
	profileMoneyChangeList(data){
		return request({url: '/profile/moneyChangeList',method: 'post',data})		
	},
	//产品管理  余额详情筛选项
	moneyChangeKindOptions(data){
		return request({url: '/profile/moneyChangeKindOptions',method: 'post',data})		
	},
	//产品管理 设置IP白名单
	setIpWhitelist(data){
		return request({url: '/profile/setIpWhitelist',method: 'post',data})		
	},
	//产品管理  产品配置
	// profile/productConfigs
	productConfigs(data){
		return request({url: '/profile/productConfigs',method: 'post',data})		
	},
	//提卡记录  列表查询
	// card_Order/allList
	cardOrderAllList(data){
		return request({url: '/card_Order/allList',method: 'post',data})		
	},
	//提卡记录 锁卡
	lockCard(data){
		return request({url: '/card_Order/lockCard',method: 'post',data})		
	},
	// 提卡记录 解锁
	unlockCard(data){
		return request({url: '/card_Order/unlockCard',method: 'post',data})
	},
	//提卡记录 面值查询
	getFaceValueList(data){
		return request({url: '/card_order/getFaceValueList',method: 'post',data})
	},
	getProductList(data){
		return request({url: '/card_order/getProductList',method: 'post',data})
	},
	//线上提卡  确认提卡
	// trader/online_card/takeCard
	takeCard(data){
		return request({url: '/online_card/takeCard',method: 'post',data})
	},
	//获取产品列表接口   卡类
	// trader/online_card/getProductList
	onlineProductList(data){
		return request({url: '/online_card/getProductList',method: 'post',data})
	},
	//获取面值
	// online_card/getFaceValueList
	onlineFaceValueList(data){
		return request({url: '/online_card/getFaceValueList',method: 'post',data})
	},
	//获取余额信息	
	getBalance(data){
		return request({url: '/online_card/getBalance',method: 'post',data})
	},
	//提卡类型筛选项列表
	getOrderTypeList(data){
		return request({url: '/online_card/getOrderTypeList',method: 'post',data})
	},
	///online_card/getCardRecords
	getCardRecords(data){
		return request({url: '/online_card/getCardRecords',method: 'post',data})
	},
	// - `GET /trader/profile/getCkConfig` - 获取当前商户CK配置
	getCkConfig(data){
		return request({url: '/profile/getCkConfig',method: 'post',data})
	},
	// - `POST /trader/profile/saveCkConfig` - 保存当前商户CK配置
	saveCkConfig(data){
			return request({url: '/profile/saveCkConfig',method: 'post',data})
		},
	// - `POST /trader/profile/checkCkValid` - 验证CK是否生效
	checkCkValid(data){
		return request({url: '/profile/checkCkValid',method: 'post',data})
	},
	//添加CK配置 profile/addCkConfig
	addCkConfig(data){
		return request({url: '/profile/addCkConfig',method: 'post',data})
	},
	//编辑ckk配置 profile/updateCkConfig
	updateCkConfig(data){
		return request({url: '/profile/updateCkConfig',method: 'post',data})
	},
	//删除ck配置 profile/deleteCkConfig
	deleteCkConfig(data){
		return request({url: '/profile/deleteCkConfig',method: 'post',data})
	},
	getInvalidCkList (data){
		return request({url: '/profile/getInvalidCkList',method: 'post',data})
	},
	// 获取闲鱼链接配置列表 /trader/profile/getXianyuLinks`
	getXianyuLinks (data){
		return request({url: '/profile/getXianyuLinks',method: 'post',data})
	},
	//添加闲鱼链接配置 trader/profile/addXianyuLink`
	addXianyuLink (data){
		return request({url: '/profile/addXianyuLink',method: 'post',data})
	},
	//获取闲鱼接单全局开关 profile/getXianyuEnabled
	getXianyuEnabled (data){
		return request({url: '/profile/getXianyuEnabled',method: 'post',data})
	},

	//设置闲鱼接单全局开关 /profile/setXianyuEnabled
	setXianyuEnabled (data){
		return request({url: '/profile/setXianyuEnabled',method: 'post',data})
	},
	//设置产品级别的闲鱼接单开关 profile/setProductXianyuEnabled
	setProductXianyuEnabled (data){
		return request({url: '/profile/setProductXianyuEnabled',method: 'post',data})
	},
	//批量保存闲鱼链接配置 profile/batchSaveXianyuLinks
	batchSaveXianyuLinks (data){
		return request({url: '/profile/batchSaveXianyuLinks',method: 'post',data})
	},
	//识别二维码图片 获取链接   profile/recognizeQrCode
	recognizeQrCode (data){
		return request({url: '/profile/recognizeQrCode',method: 'post',data,isFormData:true})
	},
	//删除闲鱼链接配置 profile/deleteXianyuLink
	deleteXianyuLink (data){
		return request({url: '/profile/deleteXianyuLink',method: 'post',data})
	},

	
}